import { api_getValueOrErrorMessage } from "./util";

export interface dailyspinGifts_gift {
  id: string;
  color?: string;
}

export interface dailyspinGifts {
  gifts: dailyspinGifts_gift[];
}

export interface dailyspinOfferCode {
  code: string;
  pc_discount: number;
  time_creation: number;
  time_expiration: number;
}

export interface dailyspinSpin {
  id?: string;
  gift?: dailyspinGifts_gift | string;
  offer_code?: dailyspinOfferCode;
  days?: number;
  tokens?: number;
}

export const api_getDailySpinGifts = async () => {
  return await api_getValueOrErrorMessage<dailyspinGifts>("dailyspin/gifts");
};

const devSpinMock: dailyspinSpin = {
  gift: "subscription_discount_35",
  offer_code: {
    code: "promo35",
    pc_discount: 35,
    time_creation: 1770993409,
    time_expiration: 1770997009,
  },
};

export const api_getDailySpinSpin = async () => {
  if (process.env.NODE_ENV === "development") {
    return devSpinMock;
  }
  return await api_getValueOrErrorMessage<dailyspinSpin>("dailyspin/spin");
};
